module.exports = __webpack_public_path__ + "img/4.dc1af8f1.jpg";